export default {
  home: {
    de: '/de/start',
    en: '/en/home',
  },
  register: {
    de: '/de/registrieren',
    en: '/en/register',
  },
  'embedded-register': {
    de: '/webviews/de/registrieren',
    en: '/webviews/en/register',
  },
  'self-service': {
    de: '/de/kundenbereich',
    en: '/en/self-service',
  },
  'embedded-self-service': {
    de: '/de/embedded-kundenbereich',
    en: '/en/embedded-self-service',
  },
  credit: {
    de: '/de/kundenbereich/guthaben',
    en: '/en/self-service/balance',
  },
  'embedded-credit': {
    de: '/de/embedded-kundenbereich/guthaben',
    en: '/en/embedded-self-service/balance',
  },
  payment: {
    de: '/de/kundenbereich/zahlungsmittel',
    en: '/en/self-service/payment',
  },
  'embedded-payment': {
    de: '/de/embedded-kundenbereich/zahlungsmittel',
    en: '/en/embedded-self-service/payment',
  },
  'payment-update': {
    de: '/de/kundenbereich/zahlungsmittel/aendern',
    en: '/en/self-service/payment/update',
  },
  'embedded-payment-update': {
    de: '/de/embedded-kundenbereich/zahlungsmittel/aendern',
    en: '/en/embedded-self-service/payment/update',
  },
  data: {
    de: '/de/kundenbereich/daten',
    en: '/en/self-service/data',
  },
  'data-update-email': {
    de: '/de/kundenbereich/daten/email/aendern',
    en: '/en/self-service/data/update/email',
  },
  'data-update-phone': {
    de: '/de/kundenbereich/daten/telefonnummer/aendern',
    en: '/en/self-service/data/update/phone',
  },
  'data-update-password': {
    de: '/de/kundenbereich/daten/passwort/aendern',
    en: '/en/self-service/data/update/password',
  },
  'embedded-data': {
    de: '/de/embedded-kundenbereich/daten',
    en: '/en/embedded-self-service/data',
  },
  'embedded-data-update-email': {
    de: '/de/embedded-kundenbereich/daten/email/aendern',
    en: '/en/embedded-self-service/data/update/email',
  },
  'embedded-data-update-phone': {
    de: '/de/embedded-kundenbereich/daten/telefonnummer/aendern',
    en: '/en/embedded-self-service/data/update/phone',
  },
  'embedded-data-update-password': {
    de: '/de/embedded-kundenbereich/daten/passwort/aendern',
    en: '/en/embedded-self-service/data/update/password',
  },
  tariff: {
    de: '/de/kundenbereich/tarif',
    en: '/en/self-service/tariff',
  },
  'tariff-change': {
    de: '/de/kundenbereich/tarif/wechseln',
    en: '/en/self-service/tariff/change',
  },
  contract: {
    de: '/de/kundenbereich/vertrag',
    en: '/en/self-service/contract',
  },
  'contract-cancel': {
    de: '/de/kundenbereich/vertrag/kuendigen',
    en: '/en/self-service/contract/cancel',
  },
  login: {
    de: '/de/anmelden',
    en: '/en/login',
  },
  'embedded-login': {
    de: '/de/embedded-anmelden',
    en: '/en/embedded-login',
  },
  'password-reset-start': {
    de: '/de/passwort-vergessen',
    en: '/en/forgot-password',
  },
  'passwort-reset-finish': {
    de: '/de/passwort-setzen',
    en: '/en/password-reset',
  },
  privacy: {
    de: '/de/datenschutz',
    en: '/en/privacy-statement',
  },
  cancelContract: {
    de: '/de/kuendigen',
    en: '/en/kuendigen',
  },
  priceList: {
    de: '/de/preisverzeichnis',
    en: '/en/pricelist',
  },
} as Record<string, Record<string, string>>
